


import {Item, ItemCategory, ItemContainer} from "@/model/Item";
import { ElMessage } from 'element-plus'
import {Options, Vue} from "vue-class-component";
import RESTService from "@/services/RESTService";

@Options({
  props: {
    itemContainer: {
      type: Object as () => ItemContainer,
    },
    editable: Boolean,
    creatable: Boolean,
    buyable: Boolean,
    useMemberPrice: Boolean,
  }
})
export default class ShopItem extends Vue {
  itemContainer!: ItemContainer
  editable = false
  creatable = false
  buyable = false
  useMemberPrice = false
  popoverVisible = false
  memberPriceEnabled = false
  memberPrice = 0

  get item(): Item {
    return this.itemContainer.item
  }

  get memberPriceValue(): number | undefined {
    const value = this.item.groupPrices.get("member")
    return value === undefined ? undefined : Number(value)
  }

  //Needed to avoid jumping between tabs
  private selectedCategory: ItemCategory = this.item.category

  created() {
    this.syncMemberPriceState()
  }

  async reloadItem() {
    this.syncMemberPriceState()
    this.$forceUpdate()
  }

  async deleteItem() {
    await RESTService.deleteItem(this.item.id)
    ElMessage({
      message: 'Artikel erfolgreich gelöscht',
      type: 'success',
    })
    this.$emit("itemChanged")
  }

  async saveItem() {
    this.item.category = this.selectedCategory
    this.applyMemberPriceToItem()
    this.popoverVisible = false
    if (this.itemContainer.item.id.length > 0)
      await RESTService.updateItem(this.item)
    else {
      await RESTService.createItem(this.item)
    }
    ElMessage({
      message: 'Artikel erfolgreich gespeichert',
      type: 'success',
    })
    this.$emit("itemChanged")
  }

  handleChange(currentValue: number) {
    this.$emit("quantityChanged")
  }

  handleMemberPriceToggle() {
    if (!this.memberPriceEnabled) {
      this.memberPrice = 0
    }
  }

  private syncMemberPriceState() {
    const memberPrice = this.readMemberPrice()
    this.memberPriceEnabled = memberPrice !== undefined
    this.memberPrice = memberPrice ?? 0
  }

  private readMemberPrice(): number | undefined {
    return this.item.groupPrices.get("member")
  }

  private applyMemberPriceToItem() {
    if (this.memberPriceEnabled) {
      this.item.groupPrices.set("member", Number(this.memberPrice))
    } else {
      this.item.groupPrices.delete("member")
    }
  }

  formatPrice(value: number): string {
    return Number(value).toFixed(2)
  }

}
